import React, { useRef } from "react";
import { AppointmentScheduleCheckout } from "@obby/components";
import { WidePopup } from "@obby/components";
import * as settings from "~/settings";

export function CheckoutAppointmentSchedulePopupView({
  course,
  location,
  onCheckoutLogin,
  onClose,
  onConfirmFreeBooking,
  onGetPaymentIntent,
  onValidateDiscount,
  ticketTypes,
  unavailableTimeBlocks,
  user
}: Props) {
  const popupWrapperRef = useRef<HTMLDivElement>(null);

  function onStepChange() {
    popupWrapperRef.current &&
      popupWrapperRef.current.scrollTo({
        top: 0
      });
  }

  return (
    <WidePopup onClose={onClose} wrapperRef={popupWrapperRef}>
      <AppointmentScheduleCheckout
        course={course}
        location={location}
        discount={course.discount}
        onConfirmFreeBooking={onConfirmFreeBooking}
        onGetPaymentIntent={onGetPaymentIntent}
        onLogin={onCheckoutLogin}
        onStepChange={onStepChange}
        onValidateDiscount={onValidateDiscount}
        stripePublicKey={settings.stripe.publicKey}
        ticketTypes={ticketTypes}
        unavailableTimeBlocks={unavailableTimeBlocks}
        user={user}
      />
    </WidePopup>
  );
}

interface Props {
  course: any;
  location?: any;
  onCheckoutLogin?: () => Promise<any>;
  onClose: () => void;
  onConfirmFreeBooking: (data: any) => void;
  onGetPaymentIntent: (
    data: any
  ) => Promise<{ clientSecret: string; successUrl: string }>;
  onValidateDiscount: (code: string, email: string) => Promise<any>;
  ticketTypes: any[];
  user?: any;
  unavailableTimeBlocks: any[];
}
